import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
// @ts-ignore

import TwoTouchHandler from "./two_touch";
const ZOOM_THRESHOLD = 0.1;
function getZoomDelta(distance, lastDistance) {
  return Math.log(distance / lastDistance) / Math.LN2;
}
export default class TouchZoomHandler extends TwoTouchHandler {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "distance", void 0);
    _defineProperty(this, "startDistance", void 0);
  }
  reset() {
    super.reset();
    // @ts-ignore
    delete this.distance;
    // @ts-ignore
    delete this.startDistance;
  }
  start(points) {
    this.startDistance = this.distance = points[0].dist(points[1]);
  }
  move(points, pinchAround) {
    const lastDistance = this.distance;
    this.distance = points[0].dist(points[1]);
    if (!this.active && Math.abs(getZoomDelta(this.distance, this.startDistance)) < ZOOM_THRESHOLD) {
      return;
    }
    this.active = true;
    return {
      zoomDelta: getZoomDelta(this.distance, lastDistance),
      pinchAround
    };
  }
}